const error404 = {
    title: 'Error 404',
    message: 'The page you’re looking for doesn’t exist',
    link: 'Home',
}

export default error404
